import {useEffect, useState} from "react";
import {t} from "i18next";
import PropTypes from "prop-types";

import CloseBtn from "../../utilities/Buttons/CloseBtn";
import {swalCustom} from "../../utilities/hooks/swalCustom";
import {toaster} from "../../utilities/hooks/toaster";

const ModalForm = ({
  label,
  active,
  setModalActive,
  Component,
  onModalClose = () => {},
  closable = false,
  closableOnEsc = true,
  canBeClosed = true, //does not remove close btn; to add conditional closing
  className = "",
  modalInnerWrapperClassName = "",
  style,
  askBeforeClose = false,
  beforeCloseSwalTest,
  ...props
}) => {
  const [couldClose, setCouldClose] = useState(canBeClosed);
  const [onCloseProps, setOnCloseProps] = useState({areValuesChanged: false});

  useEffect(() => {
    const handleKeyDown = event => {
      if (event.key === "Escape") {
        event.stopPropagation(); // Останавливаем всплытие
        if (couldClose) {
          if (askBeforeClose) {
            swalCustom.confirm({
              text: beforeCloseSwalTest,
              confirmFunc: () => {
                setModalActive(false);
                onModalClose(onCloseProps);
              },
            });
          } else {
            setModalActive(false);
          }
          if (closable && !askBeforeClose) onModalClose(onCloseProps);
        } else if (!canBeClosed) {
          onModalClose(onCloseProps);
        } else toaster.info(t("You have unsaved issues"));
      }
    };
    if (closable && closableOnEsc && active) {
      document.addEventListener("keydown", handleKeyDown);
    }
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [couldClose, onCloseProps?.areValuesChanged, active]);

  const removeFocusFromButton = isActive => {
    if (isActive) {
      const openButton = document.activeElement;
      if (openButton && openButton.blur) {
        openButton.blur(); // remove focus on button when modal was closed by Escape
      }
    }
  };

  useEffect(() => {
    removeFocusFromButton(active);
  }, [active]);

  const onCloseBtnClick = () => {
    if (!couldClose) return;

    if (askBeforeClose) {
      swalCustom.confirm({
        text: beforeCloseSwalTest,
        confirmFunc: () => {
          setModalActive(false);
          onModalClose(onCloseProps);
        },
      });
      return;
    }

    setModalActive(false);
    onModalClose(onCloseProps);
  };

  return (
    <>
      {active ? (
        <div className="modal-form__container ">
          <div className={`${className} modal_form`} style={style}>
            <label className="label modal_form_label">{label}</label>

            {closable && <CloseBtn onClick={onCloseBtnClick} />}

            <div className="overflow_form_modal">
              {/* <div></div> */}
              <div className={`${modalInnerWrapperClassName} modal_form__child`}>
                <Component
                  setModalActive={setModalActive}
                  active={active}
                  setCouldModalClose={setCouldClose}
                  onModalClose={onModalClose}
                  setOnCloseProps={setOnCloseProps}
                  {...props}
                />
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

ModalForm.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  active: PropTypes.bool,
  setModalActive: PropTypes.func,
  Component: PropTypes.func,
  onModalClose: PropTypes.func,
  closable: PropTypes.bool,
  modalInnerWrapperClassName: PropTypes.string,
  className: PropTypes.string,
  props: PropTypes.array,
};

export default ModalForm;
